<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'document-manage',
    subject: 'Clinical',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-stethoscope-line',
  color: 'info',
  title: 'Layanan Klinis (SOP Klinis, Formularium, Audit PPI)',
  description: 'Mengelola dokumen klinis, daftar obat, dan audit kepatuhan PPI/Hand Hygiene.',
  purpose: 'Panduan tiga fitur khusus layanan klinis: SOP Klinis, Formularium obat, dan Audit PPI.',
  concept: [
    {
      icon: 'ri-file-text-line',
      title: 'SOP Klinis Memakai Mesin Dokumen yang Sama',
      text: 'SOP Klinis bukan fitur terpisah — ia dikelola lewat halaman Dokumen biasa, hanya dipilih kategori "SOP Klinis" saat membuat. Lihat panduan "Kelola Dokumen" untuk detail lengkapnya.',
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Formularium = Daftar Obat',
      text: 'Daftar obat yang tersedia di fasilitas Anda, termasuk penanda "High Alert" untuk obat yang butuh kewaspadaan ekstra (mis. Insulin, KCl).',
    },
  ],
  steps: [
    { title: 'SOP Klinis: buka menu Layanan Klinis → SOP Klinis', detail: 'Klik "Buat SOP" untuk diarahkan ke form Dokumen dengan kategori sudah terisi otomatis.' },
    { title: 'Formularium: buka menu Layanan Klinis → Formularium', detail: 'Klik "Tambah Obat", isi Nama, Kategori, dan centang "High Alert" bila perlu.' },
    { title: 'Audit PPI: buka menu Layanan Klinis → Audit PPI', detail: 'Pilih template checklist PPI/Hand Hygiene, isi seperti checklist biasa.' },
  ],
  tips: [
    'Obat High Alert akan tampil dengan penanda merah di daftar Formularium — pastikan penandaan ini akurat karena dipakai staf lain sebagai peringatan.',
  ],
  faq: [
    { q: 'Apakah SOP Klinis dan SOP biasa dua sistem berbeda?', a: 'Tidak — keduanya dokumen yang persis sama secara teknis, hanya beda kategori. Semua fitur Dokumen (approval, versi, dst.) berlaku sama.' },
  ],
  related: [
    { title: 'Kelola Dokumen', sub: 'Siklus hidup dokumen lengkap', icon: 'ri-file-text-line', color: 'primary', to: { name: 'help-dokumen-kelola-dokumen' } },
    { title: 'Isi Checklist Harian', sub: 'Cara mengisi checklist Audit PPI', icon: 'ri-checkbox-multiple-line', color: 'success', to: { name: 'help-checklist-isi-checklist' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
